import { DropdownItemType } from '../components/form/dropdowns'
import { TicketTypePreference } from '../api-clients/api-types'

export const ticketTypeSeniorCitizenText = 'Honnør'
export const ticketTypeAdultText = 'Voksen'
export const ticketTypeStudentText = 'Student'
export const ticketTypePreferenceItems: DropdownItemType[] = [
  {
    label: ticketTypeAdultText,
    value: ticketTypeAdultText,
  },
  {
    label: ticketTypeSeniorCitizenText,
    value: ticketTypeSeniorCitizenText,
  },
]

export const ticketTypePreference = (inputValue?: string): TicketTypePreference =>
  inputValue === ticketTypeSeniorCitizenText ? TicketTypePreference.SENIOR_CITIZEN : TicketTypePreference.ADULT
